export class MainNavBarEnum {
  static DASHBOARD = "dashboard";
  static KPI_DASHBOARD = "kpi-dashboard";
  static DASHBOARD_ANALYTICS = "dashboard-analytics";
  static SEARCH_CLIENTS = "search-clients";
  static ADD_CLIENT = "add-client";
  static PROVIDER_MAP = "provider-map";
  static APPOINTMENT_CALENDAR = "appointment-calendar";
  static ANALYTICS = "analytics";
  static CLIENT_DETAIL = "client-detail";
  static REPORTS = "reports";
  static USER_MANAGER = "user-manager";
  static AI_SUMMARY = "ai-summary";
}
